@if (loading || (!loading && noData)) {
  <div class="message-container">
    @if (loading) {
      <div class="loading-wrapper">
        <i class="loading-icon fas fa-spinner"></i>
        <pre>Loading...</pre>
      </div>
    }
    @if (!loading && noData) {
      <div>
        <pre [style.font-size]="'large'">Feature not available for this project...</pre>
      </div>
    }
  </div>
}

<div class='contents-container' (click)="clearCheckedContent()">
  @if (!loading && !noData && activeDirectory) {
    <ng-container *ngTemplateOutlet="viewMode === 'TABLE' ? tableView : iconView"></ng-container>
  }
</div>

<!-- Icon view for contents -->
<ng-template #iconView>
  @for (content of activeDirectory.contents; track content; let index = $index) {
    <div title="{{ content.details.name }}" class="content-wrapper"
      (click)="showFileMenu = false; checkContent(content, $event['shiftKey'] ? true : false); $event.stopPropagation()"
      (dblclick)="content.details.type !== 'FILE' ? setActiveDirectory(index) : null"
      [class.checked]="checkedContent.includes(content)"
      >
            <i class="icon fas" [ngClass]="{
                'fa-file': content.details.type === 'FILE',
                'fa-folder': content.details.type === 'DIRECTORY',
                'fa-file-archive': content.details.type === 'BACKUP'
            }"></i>
      <div class='content-name'>{{ content.details.name }}</div>
    </div>
  }
</ng-template>

<!-- Table view for contents -->
<ng-template #tableView>
  <table class="table table-hover table-sm">
    <thead>
      <tr>
        <th class="no-sort checkbox">
          <input type="checkbox"
            [checked]="activeDirectory.contents.length > 0 && checkedContent.length === activeDirectory.contents.length"
            (click)="checkAll(); $event.stopPropagation()"
            >
        </th>
        <th class="no-sort" [style.width.px]="26"><i title="Tagged?" class="fas fa-tag"></i></th>
        <th scope="col"
          [ngClass]="currentSortingMethod === 'NAME' ? 'fa-sort-' + currentSortingDirection.toLowerCase() : null"
          (click)="changeSortingMethod('NAME'); $event.stopPropagation()"
          [style.width.%]="activeDirectory.details.type === 'MEDIA' ? 100 : undefined">
          <i class="table-icon fas fa-folder"></i>
          Name
        </th>

        @if (activeDirectory.details.type !== 'MEDIA' && activeDirectory.details.type !== 'PARENT') {
          <th class='date-col' scope="col"
            [ngClass]="currentSortingMethod === 'CREATED_DATE' ? 'fa-sort-' + currentSortingDirection.toLowerCase() : null"
            (click)="changeSortingMethod('CREATED_DATE'); $event.stopPropagation()">
            Created
          </th>
          <th class='date-col' scope="col"
            [ngClass]="currentSortingMethod === 'ACCESS_DATE' ? 'fa-sort-' + currentSortingDirection.toLowerCase() : null"
            (click)="changeSortingMethod('ACCESS_DATE'); $event.stopPropagation()">
            Accessed
          </th>
          <th class='date-col' scope="col"
            [ngClass]="currentSortingMethod === 'MODIFY_DATE' ? 'fa-sort-' + currentSortingDirection.toLowerCase() : null"
            (click)="changeSortingMethod('MODIFY_DATE'); $event.stopPropagation()">
            Modified
          </th>
          <th class="last-col" scope="col"
            [ngClass]="currentSortingMethod === 'SIZE' ? 'fa-sort-' + currentSortingDirection.toLowerCase() : null"
            (click)="changeSortingMethod('SIZE'); $event.stopPropagation()">
            Size
          </th>
          <th class="col-sm no-sort" scope="col">
            <i title="Deleted?" class="fas fa-trash"></i>
          </th>
        }

        @if (activeDirectory.details.type === 'MEDIA') {
          <th class='date-col' scope="col"
            [ngClass]="currentSortingMethod === 'CREATED_DATE' ? 'fa-sort-' + currentSortingDirection.toLowerCase() : null"
            (click)="changeSortingMethod('CREATED_DATE'); $event.stopPropagation()">
            Date
          </th>
          <th class="last-col" scope="col"
            [ngClass]="currentSortingMethod === 'CREATED_DATE' ? 'fa-sort-' + currentSortingDirection.toLowerCase() : null"
            (click)="changeSortingMethod('CREATED_DATE'); $event.stopPropagation()">
            Time
          </th>
          <th class="last-col" scope="col"
            [ngClass]="currentSortingMethod === 'SIZE' ? 'fa-sort-' + currentSortingDirection.toLowerCase() : null"
            (click)="changeSortingMethod('SIZE'); $event.stopPropagation()">
            Size
          </th>
        }
      </tr>
    </thead>
    <tbody>
      <!-- rows read fields from several InvDataDetails variants (file, media, backup), so the row is left untyped -->
      @for (content of $any(sortedContents); track content; let index = $index) {
        <tr class='content-wrapper-row' title="{{ content.details.name }}"
          (click)="viewContentDetails(content); $event.stopPropagation()"
          (dblclick)="content.details.type !== 'FILE' ? setActiveDirectory(index) : null"
          [class.checked]="checkedContent.includes(content)"
          [class.selected]="selectedDataDetails && selectedDataDetails.id === content.details.id"
          >
          <td class="checkbox"><input type="checkbox"  [checked]="checkedContent.includes(content)" (click)="checkContent(content, true); $event.stopPropagation()" /></td>
          <td>@if (content.details.tagged) {
            <i title="tagged" class="fas fa-tag"></i>
          }</td>
                    <td class="name" title="{{ content.details.name }}"><i class="table-icon fas" [ngClass]="{
                        'fa-file': content.details.type === 'FILE',
                        'fa-folder': content.details.type === 'DIRECTORY'
                    }"></i>{{ content.details.name || '{inv-unknown}' }}</td>
          @if (activeDirectory.details.type !== 'MEDIA' && activeDirectory.details.type !== 'PARENT') {
            <td class='date-col' [title]="secondsToMilliseconds(content.details.createDate) | date:'short'">{{ secondsToMilliseconds(content.details.createDate) | date:'shortDate' }}</td>
            <td class='date-col' [title]="secondsToMilliseconds(content.details.accessDate) | date:'short'">{{ secondsToMilliseconds(content.details.accessDate) | date:'shortDate' }}</td>
            <td class='date-col' [title]="secondsToMilliseconds(content.details.modifyDate) | date:'short'">{{ secondsToMilliseconds(content.details.modifyDate) | date:'shortDate' }}</td>
            <td ngPreserveWhitespaces class="last-col">{{ content.details.type === 'FILE' || content.details.type === 'DIRECTORY' ? formatBytes(content.details.size) : '' }}</td>
            <td class="col-sm" scope="col">
              @if (content.details.type === 'FILE' && content.details.deleted) {
                <i title="deleted" class="fas fa-trash td-trash-icon"></i>
              }
            </td>
          }
          @if (activeDirectory.details.type === 'MEDIA') {
            <td class='date-col' [title]="secondsToMilliseconds(content.details.backupDate) | date:'shortDate'">{{ secondsToMilliseconds(content.details.backupDate) | date:'shortDate' }}</td>
            <td class='date-col' [title]="secondsToMilliseconds(content.details.backupDate) | date:'shortTime'">{{ secondsToMilliseconds(content.details.backupDate) | date:'shortTime' }}</td>
            <td ngPreserveWhitespaces class="last-col">{{ formatBytes(content.details.size) }}</td>
          }
        </tr>
      }
      @if (activeDirectory.contents.length === 0) {
        <tr>
          <td [style.font-size.rem]="1.5" colspan="5">{{ count === 999999 ? 'Files Not Shown Due To User Cancelation' : 'No content' }}</td>
        </tr>
      }
    </tbody>
  </table>
</ng-template>